// extracted by mini-css-extract-plugin
export default {"link-whats":"botao-whats_link-whats__lcgjC"};